export default {
  // Navigation
  nav_home: 'ہوم',
  nav_dashboard: 'ڈیش بورڈ',
  nav_orders: 'آرڈرز',
  nav_wallet: 'والٹ',
  nav_analytics: 'تجزیات',
  nav_referral: 'ریفرل',
  nav_account: 'اکاؤنٹ',
  nav_notifications: 'اطلاعات',
  nav_logout: 'لاگ آؤٹ',
  nav_login: 'لاگ ان',
  nav_signup: 'سائن اپ',
  nav_deposit_requests: 'ڈیپازٹ کی درخواستیں',
  nav_withdraw_requests: 'ودرا کی درخواستیں',
  nav_support_ticket: 'سپورٹ ٹکٹ',
  nav_system_logs: 'سسٹم لاگز',
  nav_announcements: 'اعلانات',
  nav_activity_logs: 'سرگرمی لاگز',
  nav_settings: 'ترتیبات',
  nav_section_main: 'مین',
  nav_user_active: 'ابھی فعال ہے',
  nav_more: 'مزید',
  nav_logout_confirm: 'کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟',
  nav_language: 'زبان',

  // Dashboard
  dashboard_welcome: 'خوش آمدید',
  dashboard_total_earnings: 'کل کمائی',
  dashboard_pending_orders: 'زیر التواء آرڈرز',
  dashboard_completed_orders: 'مکمل آرڈرز',
  dashboard_commission_rate: 'کمیشن کی شرح',
  dashboard_quick_actions: 'فوری اقدامات',
  dashboard_recent_orders: 'حالیہ آرڈرز',
  dashboard_recent_activity: 'حالیہ سرگرمی',
  dashboard_wallet_balance: 'والٹ بیلنس',
  dashboard_deposit: 'ڈیپازٹ',
  dashboard_withdraw: 'ودرا',
  dashboard_view_all: 'سب دیکھیں',
  greeting_morning: 'صبح بخیر',
  greeting_afternoon: 'سہ پہر بخیر',
  greeting_evening: 'شام بخیر',
  dashboard_greeting_desc: 'اپنی کمائی کو ٹریک کریں، آرڈرز مکمل کریں، اور اپنے اکاؤنٹ کا انتظام ایک ہی جگہ پر کریں۔ آپ کی کامیابی کا سفر یہاں جاری ہے!',

  // Dashboard Stats
  stats_available_balance: 'دستیاب بیلنس',
  stats_total_withdrawn: 'کل نکلوائی گئی رقم',
  stats_total_deposit: 'کل ڈیپازٹ',
  stats_pending_orders: 'زیر التواء آرڈرز',
  stats_orders_suffix: ' آرڈرز',
  stats_task_earnings: 'ٹاسک کمائی',
  stats_lifetime_earning: 'لائف ٹائم کمائی',

  // Orders
  orders_title: 'میرے آرڈرز',
  orders_all: 'تمام آرڈرز',
  orders_pending: 'زیر التواء',
  orders_completed: 'مکمل',
  orders_cancelled: 'منسوخ',
  orders_order_id: 'آرڈر آئی ڈی',
  orders_platform: 'پلیٹ فارم',
  orders_amount: 'رقم',
  orders_commission: 'کمیشن',
  orders_status: 'صورتحال',
  orders_date: 'تاریخ',
  orders_actions: 'اقدامات',
  orders_no_orders: 'کوئی آرڈرز نہیں ملے',
  orders_step_1: 'مصنوعات کی تفصیلات کا جائزہ',
  orders_step_2: 'آرڈر کی معلومات کی تصدیق',
  orders_step_3: 'پلیٹ فارم سے رابطہ',
  orders_step_4: 'پروموشن جمع کروانا',
  orders_step_5: 'SEO Indexing',
  orders_step_6: 'Boosting Visibility',
  orders_step_7: 'حتمی شکل اور تصدیق',
  orders_btn_optimize: 'آرڈر کو بہتر بنائیں',
  orders_btn_claim_commission: 'کمیشن کا دعوی کریں',
  orders_btn_task_completed: 'ٹاسک مکمل',
  orders_price_label: 'آرڈر کی قیمت',
  orders_commission_rate_label: 'کمیشن کی شرح',

  // Wallet
  wallet_title: 'میرا والٹ',
  wallet_available_balance: 'دستیاب بیلنس',
  wallet_pending_balance: 'زیر التواء بیلنس',
  wallet_total_withdrawn: 'کل نکلوائی گئی رقم',
  wallet_deposit_now: 'ابھی ڈیپازٹ کریں',
  wallet_withdraw_now: 'ابھی ودرا کریں',
  wallet_transaction_history: 'لین دین کی تاریخ',
  wallet_deposit_history: "ڈیپازٹ کی تاریخ",
  wallet_withdrawal_history: 'ودرا کی تاریخ',
  wallet_deposit_desc: "دستیاب ادائیگی کے طریقوں سے اپنے والٹ میں رقم شامل کریں۔",
  wallet_no_deposits: "کوئی جمع نہیں ملا۔",
  wallet_withdraw_history: "نکالنے کی تاریخ",
  wallet_withdraw_desc: "آپ کے بٹوے سے رقم نکالیں۔",
  wallet_no_withdrawals: "کوئی نکالنا نہیں ملا۔",
  wallet_no_withdrawals_desc: "آپ نے ابھی تک کوئی رقم نہیں نکلوائی ہے۔",
  withdrawal_restricted_title: 'رقم نکالنا محدود ہے',
  withdrawal_restricted_message: 'رقم نکلوانے کی سہولت فی الحال آپ کے اکاؤنٹ کے لیے دستیاب نہیں ہے۔ مزید معلومات کے لیے براہ کرم کسٹمر سپورٹ سے رابطہ کریں۔',

  // Analytics
  analytics_title: 'تجزیات',
  analytics_earnings_overview: 'کمائی کا جائزہ',
  analytics_platform_breakdown: 'پلیٹ فارم کی تفصیل',
  analytics_performance_metrics: 'کارکردگی کے میٹرکس',
  analytics_top_products: 'ٹاپ پروڈکٹس',
  analytics_this_month: 'اس مہینے',
  analytics_last_month: 'پچھلے مہینے',
  analytics_total_revenue: 'کل آمدنی',
  analytics_avg_order_value: 'اوسط آرڈر ویلیو',

  // Security
  security_row_title: 'سیکیورٹی کی ترتیبات',
  security_login_pw: 'لاگ ان پاس ورڈ',
  security_login_pw_desc: 'اپنے اکاؤنٹ کا لاگ ان پاس ورڈ تبدیل کریں',
  security_change_btn: 'تبدیل کریں',
  security_set_withdrawal_pw_title: 'وتھڈرال پاس ورڈ سیٹ کریں',
  security_set_withdrawal_pw_desc: 'وتھڈرال کی اجازت دینے کے لیے ایک الگ پن (PIN) بنائیں',
  security_set_withdrawal_pw_btn: 'پن سیٹ کریں',
  security_change_withdrawal_pw_title: 'وتھڈرال پاس ورڈ تبدیل کریں',
  security_change_withdrawal_pw_desc: 'اپنا موجودہ وتھڈرال پن اپ ڈیٹ کریں',
  security_change_withdrawal_pw_btn: 'تبدیل کریں',
  security_modal_set_withdrawal_title: 'وتھڈرال پاس ورڈ سیٹ کریں',
  security_modal_set_withdrawal_subtitle: 'جب بھی آپ ودڈرال کریں گے تو یہ پن درکار ہوگا۔',
  security_modal_change_withdrawal_title: 'وتھڈرال پاس ورڈ تبدیل کریں',
  security_field_current_pin: 'موجودہ وتھڈرال پن',
  security_field_new_pin: 'نیا وتھڈرال پن',
  security_field_new_pin_6: 'نیا وتھڈرال پن (6 ہندسے)',
  security_field_confirm_pin: 'پن کی تصدیق کریں',
  security_field_confirm_new_pin: 'نئے پن کی تصدیق کریں',
  security_placeholder_pin_dots: '......',
  security_pw_current: 'موجودہ پاس ورڈ',

  // Referral
  referral_title: 'ریفرل پروگرام',
  referral_your_code: 'آپ کا ریفرل کوڈ',
  referral_copy_code: 'کوڈ کاپی کریں',
  referral_share_link: 'لنک شیئر کریں',
  referral_total_referrals: 'کل ریفرلز',
  referral_active_referrals: 'فعال ریفرلز',
  referral_referral_earnings: 'ریفرل کمائی',
  referral_invite_friends: 'دوستوں کو مدعو کریں',

  // Account
  account_title: 'اکاؤنٹ کی ترتیبات',
  account_profile: 'پروفائل',
  account_security: 'سیکیورٹی',
  account_notifications: 'اطلاعات',
  account_kyc: 'کے وائی سی کی تصدیق',
  account_phone: 'فون نمبر',
  account_two_factor: 'دو قدمی تصدیق',
  account_save_changes: 'تبدیلیاں محفوظ کریں',
  account_cancel: 'منسوخ کریں',

  // Auth & Common
  auth_email: 'ای میل',
  auth_password: 'پاس ورڈ',
  auth_confirm_password: 'پاس ورڈ کی تصدیق کریں',
  auth_forgot_password: 'پاس ورڈ بھول گئے؟',
  auth_remember_me: 'مجھے یاد رکھیں',
  auth_login_button: 'لاگ ان',
  auth_signup_button: 'سائن اپ',
  auth_already_have_account: 'پہلے سے اکاؤنٹ ہے؟',
  auth_dont_have_account: "اکاؤنٹ نہیں ہے؟",
  auth_reset_password: 'پاس ورڈ ری سیٹ کریں',
  auth_verify_email: 'ای میل کی تصدیق کریں',
  auth_live_platform: 'لائیو پلیٹ فارم',
  auth_security_verification: 'سیکیورٹی تصدیق',
  auth_captcha_refresh: 'ری فریش',
  auth_captcha_placeholder: 'نتیجہ',
  auth_captcha_error: 'غلط مجموعہ، دوبارہ کوشش کریں',
  auth_branding_title: 'پروموشنز کو بدلیں',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'حقیقی آمدنی میں',
  auth_branding_desc: 'ان ہزاروں پروموٹرز میں شامل ہوں جو دنیا بھر کے ٹاپ ای کامرس برانڈز سے روزانہ کمیشن کماتے ہیں۔',
  auth_sign_in_to_account: 'اپنے {{system_name}} اکاؤنٹ میں سائن ان کریں',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'اپنا پاس ورڈ درج کریں',
  auth_signing_in: 'سائن ان ہو رہا ہے...',
  auth_free_to_join: 'شامل ہونا مفت ہے',
  auth_signup_branding_title: 'کمائی شروع کریں',
  auth_signup_branding_highlight: 'پہلے دن سے',
  auth_signup_branding_desc: 'کسی تجربے کی ضرورت نہیں۔ 2 منٹ میں سائن اپ کریں اور ٹاپ ای کامرس برانڈز کے لیے ٹاسک مکمل کرنا شروع کریں۔',
  auth_how_it_works: 'یہ کیسے کام کرتا ہے',
  auth_signup_desc: '{{system_name}} میں شامل ہوں اور آج ہی کمیشن کمانا شروع کریں - یہ مفت ہے!',
  auth_step_1: 'اپنا مفت اکاؤنٹ بنائیں',
  auth_step_2: 'ٹاسکس دیکھیں اور قبول کریں',
  auth_step_3: 'مکمل کریں اور کمیشن کمائیں',
  auth_signup_step_1_title: 'اکاؤنٹ بنائیں',
  auth_signup_step_1_desc: 'اپنا سفر شروع کریں',
  auth_signup_step_2_title: 'ٹاسکس مکمل کریں',
  auth_signup_step_2_desc: 'روزانہ کمیشن کمائیں',
  auth_signup_step_3_title: 'رقم نکلوانا',
  auth_signup_step_3_desc: 'فوری اور محفوظ ادائیگیاں',
  auth_benefit_1_title: 'محفوظ اور قابل اعتماد',
  auth_benefit_1_desc: 'آپ کی کمائی کے لیے بینک لیول سیکیورٹی',
  auth_benefit_2_title: 'فوری ادائیگیاں',
  auth_benefit_2_desc: '24 گھنٹوں کے اندر اپنی کمائی نکلوائیں',
  auth_benefit_3_title: 'عالمی برادری',
  auth_benefit_3_desc: '12,000 سے زیادہ فعال پروموٹرز میں شامل ہوں',
  auth_benefit_4_title: '24/7 سپورٹ',
  auth_benefit_4_desc: 'جب بھی ضرورت ہو مدد حاصل کریں',

  common_loading: 'لوڈنگ ہو رہی ہے...',
  common_save: 'محفوظ کریں',
  common_cancel: 'منسوخ کریں',
  common_delete: 'حذف کریں',
  common_edit: 'ترمیم کریں',
  common_view: 'دیکھیں',
  common_search: 'تلاش کریں',
  common_filter: 'فلٹر',
  common_export: 'ایکسپورٹ',
  common_import: 'امپورٹ',
  common_submit: 'جمع کرائیں',
  common_close: 'بند کریں',
  common_confirm: 'تصدیق کریں',
  common_success: 'کامیابی',
  common_error: 'غلطی',
  common_warning: 'وارننگ',
  common_announcement: 'اعلان',

  val_full_name_required: 'مکمل نام ضروری ہے',
  val_email_required: 'ای میل ضروری ہے',
  val_password_required: 'پاس ورڈ ضروری ہے',
  val_password_min: 'پاس ورڈ کم از کم 8 حروف کا ہونا چاہیے',
  val_passwords_dont_match: 'پاس ورڈ مماثل نہیں ہیں',
  security_pin_6_err: 'پن کا بالکل 6 ہندسوں کا ہونا ضروری ہے۔',
  security_pin_digit_err: 'پن میں صرف ہندسے ہونے چاہئیں۔',
  val_agree_terms: 'آپ کو شرائط سے اتفاق کرنا ہوگا',
  val_conn_error: 'کنکشن کی غلطی۔ براہ کرم دوبارہ کوشش کریں۔',

  // Homepage
  home_hero_title: 'ٹاپ ای کامرس پلیٹ فارمز سے کمیشن کمائیں',
  home_hero_subtitle: 'والمارٹ، علی بابا، اور علی ایکسپریس سے روزانہ کمیشن کمانے والے ہزاروں صارفین میں شامل ہوں',
  home_get_started: 'ابھی شروع کریں',
  home_learn_more: 'مزید جانیں',
  home_how_it_works: 'یہ کیسے کام کرتا ہے',
  home_features: 'نمایاں خصوصیات',
  home_why_choose_us: 'ہمیں کیوں منتخب کریں',
  home_features_title: 'طاقتور خصوصیات',
  home_features_subtitle: 'آن لائن کمانا شروع کرنے کے لیے ہر وہ چیز جو آپ کو چاہیے۔ آپ کی کامیابی کو مدنظر رکھتے ہوئے بنایا گیا ہے۔',
  home_commission_tiers: 'کمیشن کی سطحیں',
  home_testimonials: 'ہمارے صارفین کیا کہتے ہیں',
  home_faq: 'اکثر پوچھے گئے سوالات',
  home_cta_title: 'کمائی شروع کرنے کے لیے تیار ہیں؟',
  home_cta_subtitle: 'آج ہی ہماری برادری میں شامل ہوں اور کمیشن کمانا شروع کریں',
  home_trusted_partner: 'قابل اعتماد پارٹنر پلیٹ فارمز',
  home_secure_platform: 'محفوظ پلیٹ فارم',
  home_instant_payouts: 'فوری ادائیگیاں',
  home_active_users: 'فعال صارفین',
  home_total_paid_out: 'کل ادا شدہ رقم',
  home_user_rating: 'صارف کی درجہ بندی',
  home_countries: 'ممالک',

  // Feature Section
  feature_1_title: 'فوری ادائیگیاں',
  feature_1_desc: 'آرڈر مکمل ہونے کے فوراً بعد اپنی کمائی حاصل کریں۔ کسی بھی وقت بغیر تاخیر کے نکلوائیں۔',
  feature_1_detail_1: 'ریئل ٹائم کمیشن کریڈٹ',
  feature_1_detail_2: 'رقم نکلوانے کے متعدد اختیارات',
  feature_1_detail_3: 'رقم نکالنے کی کوئی کم از کم حد نہیں',
  feature_2_title: 'محفوظ پلیٹ فارم',
  feature_2_desc: 'بینک لیول انکرپشن آپ کے ڈیٹا اور کمائی کی حفاظت کرتا ہے۔ دنیا بھر کے ہزاروں صارفین کا بھروسہ۔',
  feature_2_detail_1: 'SSL انکرپشن فعال ہے',
  feature_2_detail_2: 'دو قدمی تصدیق',
  feature_2_detail_3: 'باقاعدہ سیکیورٹی آڈٹ',
  feature_2_detail_4: 'ڈیٹا پرائیویسی کی ضمانت',
  feature_3_title: 'لچکدار گھنٹے',
  feature_3_desc: 'جب چاہیں، جہاں چاہیں کام کریں۔ بغیر کسی مقررہ شیڈول کے اپنی رفتار سے آرڈر مکمل کریں۔',
  feature_3_detail_1: 'کام کے کوئی مقررہ گھنٹے نہیں',
  feature_3_detail_2: 'کہیں سے بھی کام کریں',
  feature_3_detail_3: 'اپنی رفتار خود منتخب کریں',
  feature_3_detail_4: 'ہفتہ وار چھٹیوں پر دستیابی',
  feature_4_title: 'ترقی پذیر کمائی',
  feature_4_desc: 'زیادہ آرڈرز مکمل کرنے پر کمیشن کی اعلی شرحوں کو غیر مقفل کریں۔ ہر سطح کی اپ گریڈ کے ساتھ اپنی آمدنی بڑھائیں۔',
  feature_4_detail_1: 'سطح پر مبنی کمیشن کی شرح',
  feature_4_detail_2: 'خودکار سطح کی اپ گریڈ',
  feature_4_detail_3: 'کارکردگی کے انعامات',
  feature_5_title: 'عالمی پلیٹ فارم',
  feature_5_desc: 'دنیا میں کہیں سے بھی بین الاقوامی برانڈز کے ساتھ کام کریں۔ کثیر کرنسی سپورٹ شامل ہے۔',
  feature_5_detail_1: 'دنیا بھر میں دستیاب',
  feature_5_detail_2: 'کثیر کرنسی سپورٹ',
  feature_5_detail_3: 'مقامی ادائیگی کے طریقے',
  feature_6_title: '24/7 سپورٹ',
  feature_6_desc: 'ہماری سرشار سپورٹ ٹیم ہمیشہ مدد کے لیے تیار ہے۔ لائیو چیٹ، ای میل یا فون کے ذریعے مدد حاصل کریں۔',
  feature_6_detail_1: 'لائیو چیٹ دستیاب ہے',
  feature_6_detail_2: '24/7 ای میل سپورٹ',
  feature_6_detail_3: 'فون کی مدد',
  feature_6_detail_4: 'جامع اکثر پوچھے گئے سوالات',
  feature_7_title: 'ریفرل پروگرام',
  feature_7_desc: 'دوستوں کو مدعو کرکے اضافی آمدنی حاصل کریں۔ اپنے ریفرلز کی کمائی سے تاحیات کمیشن حاصل کریں۔',
  feature_7_detail_1: 'تاحیات ریفرل کمائی',
  feature_7_detail_2: 'لامحدود ریفرلز',
  feature_7_detail_3: 'آسان شیئرنگ ٹولز',
  feature_7_detail_4: 'بونس مراعات',
  feature_8_title: 'کثیر کرنسی سپورٹ',
  feature_8_desc: 'بڑی کرنسیوں اور ادائیگی کے طریقوں کی سپورٹ۔ وہ منتخب کریں جو آپ کے لیے بہترین ہو۔',
  feature_8_detail_1: 'USD، EUR، GBP سپورٹ',
  feature_8_detail_2: 'بینک ٹرانسفر دستیاب ہے',
  feature_8_detail_3: 'ای والٹ انٹیگریشن',
  feature_8_detail_4: 'کرپٹو آپشنز جلد آرہے ہیں',
  feature_9_title: 'فوری اطلاعات',
  feature_9_desc: 'نئے آرڈرز، کمائی اور اکاؤنٹ کی سرگرمیوں کے لیے ریئل ٹائم الرٹس کے ساتھ باخبر رہیں۔',
  feature_9_detail_1: 'پش اطلاعات',
  feature_9_detail_2: 'ای میل الرٹس',
  feature_9_detail_3: 'ایس ایم ایس اپ ڈیٹس',
  feature_9_detail_4: 'ان ایپ پیغامات',

  // Home Page Additional Sections
  home_how_it_works_badge: 'سادہ عمل',
  home_how_it_works_title: 'یہ کیسے کام کرتا ہے',
  home_how_it_works_subtitle: '4 آسان مراحل میں کمانا شروع کریں۔ کسی تجربے کی ضرورت نہیں، بس عمل کی پیروی کریں اور اپنی کمائی کو بڑھتے ہوئے دیکھیں۔',
  home_cta_ready_title: 'کیا آپ اپنا سفر شروع کرنے کے لیے تیار ہیں؟',
  home_cta_ready_desc: 'پہلے سے ہی روزانہ کمانے والے ہزاروں صارفین میں شامل ہوں۔ آپ کا پہلا کمیشن بس چند منٹ دور ہے!',
  home_cta_avg_time: 'پہلی کمائی تک اوسط وقت:',
  home_cta_15_mins: '15 منٹ',
  home_cta_new_users: 'آج نئے صارفین:',

  // How It Works Steps
  step_1_title: 'اکاؤنٹ بنائیں',
  step_1_desc: '2 منٹ سے بھی کم وقت میں اپنا اکاؤنٹ بنائیں۔',
  step_1_detail_1: 'بنیادی معلومات فراہم کریں',
  step_1_detail_2: 'اپنے ای میل کی تصدیق کریں',
  step_1_detail_3: 'اپنے اکاؤنٹ کو محفوظ بنائیں',
  step_1_detail_4: 'فوری ڈیش بورڈ رسائی',

  step_2_title: 'ٹاسک تلاش کریں',
  step_2_desc: 'دستیاب پروموشن ٹاسکس میں سے انتخاب کریں۔',
  step_2_detail_1: 'پلیٹ فارم کے لحاظ سے فلٹر کریں',
  step_2_detail_2: 'کمیشن کی شرحیں دیکھیں',
  step_2_detail_3: 'متعدد ٹاسکس قبول کریں',
  step_2_detail_4: 'ریئل ٹائم ٹاسک اپ ڈیٹس',

  step_3_title: 'ٹاسکس مکمل کریں',
  step_3_desc: 'ہدایات کے مطابق پروموشنز مکمل کریں۔',
  step_3_detail_1: 'پیروی کرنے میں آسان اقدامات',
  step_3_detail_2: 'فوری پروموشن جمع کرانا',
  step_3_detail_3: 'خودکار تصدیق',
  step_3_detail_4: 'موبائل فرینڈلی انٹرفیس',

  step_4_title: 'کمائیں اور نکلوائیں',
  step_4_desc: 'ہر مکمل ٹاسک کے لیے ادائیگی حاصل کریں۔',
  step_4_detail_1: 'ریئل ٹائم کمائی کی ٹریکنگ',
  step_4_detail_2: 'رقم نکلوانے کی کم حد',
  step_4_detail_3: 'ادائیگی کے متعدد طریقے',
  step_4_detail_4: '24/7 ودرا سپورٹ',

  // Redesigned Footer
  footer_stay_loop_title: 'باخبر رہیں',
  footer_stay_loop_desc: 'تازہ ترین اپ ڈیٹس، تجاویز اور خصوصی پیشکشیں براہ راست اپنے ان باکس میں حاصل کریں۔',
  footer_subscribe: 'سبسکرائب کریں',
  footer_subscribe_placeholder: 'اپنا ای میل پتہ درج کریں',
  footer_trusted_secure: 'قابل اعتماد اور محفوظ:',
  footer_ssl_secured: 'SSL محفوظ',
  footer_ssl_secured_desc: '256-بٹ SSL',
  footer_aes_encryption: 'AES-256 انکرپشن',
  footer_aes_encryption_desc: 'بینک گریڈ',
  footer_kyc_compliant: 'KYC کے مطابق',
  footer_kyc_compliant_desc: 'تصدیق شدہ',
  footer_gdpr_compliant: 'GDPR کے مطابق',
  footer_gdpr_compliant_desc: 'ڈیٹا محفوظ',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'تصدیق شدہ',
  footer_platform: 'پلیٹ فارم',
  footer_support: 'سپورٹ',
  footer_legal: 'قانونی',
  footer_help_center: 'ایڈوانس سنٹر',
  footer_contact_us: 'ہم سے رابطہ کریں',
  footer_payments_label: 'ادائیگیاں:',
  home_live_activity_title: 'لائیو پلیٹ فارم سرگرمی',
  home_recent_activity_title: 'حالیہ سرگرمی',
  home_total_commissions_paid: 'کل ادا شدہ کمیشن',
  home_active_users_online: 'آن لائن فعال صارفین',
  home_tasks_completed_today: 'آج مکمل کیے گئے کام',
  account_security_tips_title: 'حفاظتی سفارشات',
  account_security_tips_desc: 'ان سادہ بہترین طریقوں پر عمل کر کے اپنے اکاؤنٹ کی حفاظت کو بہتر بنائیں۔',
  tip_password_title: 'مضبوط پاس ورڈ',
  tip_password_desc: 'اپنے اکاؤنٹ کو محفوظ رکھنے کے لیے حروف، اعداد اور علامات کا مجموعہ استعمال کریں۔',
  tip_two_factor_title: 'شناخت کی تصدیق',
  tip_two_factor_desc: 'اہم حفاظتی اطلاعات موصول کرنے کے لیے اپنی رابطہ کی معلومات کو اپ ڈیٹ رکھیں۔',
  tip_logout_title: 'باقاعدگی سے لاگ آؤٹ کریں',
  tip_logout_desc: 'عوامی یا مشترکہ کمپیوٹر استعمال کرتے وقت ہمیشہ اپنے اکاؤنٹ سے لاگ آؤٹ کریں۔',
  tip_sharing_title: 'رسائی کبھی شیئر نہ کریں',
  tip_sharing_desc: 'ہماری سپورٹ ٹیم کبھی بھی آپ کا پاس ورڈ نہیں مانگے گی۔ اپنی اسناد کبھی کسی کے ساتھ شیئر نہ کریں۔',

  // آرڈر کی درخواستیں
  order_requests_title: 'آرڈر کی درخواستیں',
  order_requests_desc: 'نئے ٹاسک یا حسب ضرورت آرڈر کے لیے درخواست جمع کرائیں۔ ایڈمنسٹریٹر آپ کی درخواست کی بنیاد پر ٹاسک کا جائزہ لے گا اور تفویض کرے گا۔',
  order_requests_new_btn: 'نئے آرڈر کی درخواست کریں',
  order_requests_table_id: 'درخواست آئی ڈی',
  order_requests_table_data: 'درخواست کی تفصیلات',
  order_requests_table_status: 'حیثیت',
  order_requests_table_date: 'جمع کرائی گئی',
  order_requests_table_actions: 'عمل',
  order_requests_cancel: 'منسوخ کریں',
  order_requests_cancel_confirm: 'کیا آپ واقعی اس آرڈر کی درخواست کو منسوخ کرنا چاہتے ہیں؟',
  order_requests_cancel_success: 'آرڈر کی درخواست کامیابی کے ساتھ منسوخ کر دی گئی۔',
  order_requests_create_success: 'آرڈر کی درخواست کامیابی کے ساتھ جمع کر دی گئی۔',
  order_requests_modal_title: 'نئی آرڈر کی درخواست جمع کروائیں',
  order_requests_modal_desc: 'براہ کرم اس آرڈر کے بارے میں تفصیلی معلومات فراہم کریں جس کی آپ درخواست کرنا چاہتے ہیں۔',
  order_requests_field_data: 'آرڈر کی درخواست کا ڈیٹا',
  order_requests_field_placeholder: 'مثال کے طور پر: میں پریمیم پیکیج کے لیے حسب ضرورت آرڈر کی درخواست کرنا چاہتا ہوں۔',
  order_requests_btn_submit: 'درخواست جمع کروائیں',
  order_requests_btn_submitting: 'جمع ہو رہا ہے...',
  order_requests_empty: 'آرڈر کی کوئی درخواست نہیں ملی۔',
  order_requests_status_pending: 'زیر التواء',
  order_requests_status_approved: 'منظور شدہ',
  order_requests_status_rejected: 'مسترد شدہ',
  order_requests_status_cancelled: 'منسوخ',
  order_requests_terms_title: 'لازمی آرڈر کی شرائط',
  order_requests_term_1: 'نئے آرڈرز منظوری کے 24-48 گھنٹوں کے اندر تفویض کیے جائیں گے۔',
  order_requests_term_2: 'ایک بار جاری ہونے کے بعد، آرڈرز کو منسوخ، روکا یا تبدیل نہیں کیا جا سکتا۔',
  order_requests_term_3: 'رقم نکلوانے سے پہلے تمام تفویض کردہ آرڈرز کو مکمل کرنا ضروری ہے۔',
  order_requests_term_4: 'آرڈرز مکمل کرنے میں ناکامی آپ کے اکاؤنٹ کی حیثیت کو متاثر کر سکتی ہے۔',
  order_requests_term_5: 'یہ درخواست حتمی ہے اور جمع کرانے کے بعد اسے واپس نہیں لیا جا سکتا۔',
  order_requests_policy_title: 'منسوخی نہ کرنے کی پالیسی',
  order_requests_policy_desc: 'یہ درخواست جمع کرا کر، آپ تسلیم کرتے ہیں کہ نیا آرڈر بیچ ناقابل تنسیخ ہے۔ ایک بار جب ہمارے سسٹم کے ذریعے اس کی تصدیق ہو جائے گی، کسی بھی صورت میں منسوخی، ترمیم یا ریفنڈ کی اجازت نہیں دی جائے گی۔',
  order_requests_accept_terms: 'میں نے مذکورہ بالا شرائط کو پڑھ لیا ہے اور مکمل طور پر سمجھ لیا ہے۔ میں تسلیم کرتا ہوں کہ ایک بار جمع کرانے کے بعد، اس آرڈر کی درخواست کو منسوخ یا تبدیل نہیں کیا جا سکتا، اور میں تمام تفویض کردہ آرڈرز کو مکمل کرنے پر اتفاق کرتا ہوں۔',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'رقم نکلوانے کی پالیسی',
  orders_unlock_req: 'ان لاک کرنے کے تقاضے',
  orders_unlock_desc: 'رقم نکلوانے کی خصوصیت کو مستقل طور پر ان لاک کرنے کے لیے اپنے پہلے {{count}} آرڈرز کا بیچ مکمل کریں۔ یہ ایک وقتی ضرورت پلیٹ فارم کی سالمیت کو یقینی بناتی ہے اور غلط استعمال کو روکتی ہے۔',
  orders_daily_limits: 'یومیہ آرڈر کی حدود',
  orders_daily_limit_1: 'فی بیچ {{count}} آرڈرز — آپ کو اگلا بیچ طلب کرنے سے پہلے تمام آرڈرز مکمل کرنے ہوں گے',
  orders_daily_limit_2: 'روزانہ زیادہ سے زیادہ {{count}} بیجز (کل {{total}} آرڈرز فی دن)',
  orders_comm_rates: 'کمیشن کی شرحیں',
  orders_comm_rates_desc: 'شرحیں پلیٹ فارم اور آپ کے موجودہ والٹ بیلنس سے طے ہوتی ہیں:',
  orders_payout_timeline: 'ادائیگی کا ٹائم لائن',
  orders_payout_desc: 'ودرا کی درخواستوں پر 24 سے 48 گھنٹوں کے اندر عمل کیا جاتا ہے۔ بینک ٹرانسفر میں 3 سے 5 کاروباری دن لگ سکتے ہیں۔ کرپٹو ودرا فوری ہوتا ہے۔',
  orders_processing_fee: 'لین دین کے اخراجات کو پورا کرنے کے لیے تمام ودرا پر {{fee}}٪ پروسیسنگ فیس لاگو ہوتی ہے۔',
  orders_tips_title: 'کامیابی کے لیے نکات',
  orders_tips_1: 'رفتار بنانے اور اپنی کمائی کو زیادہ سے زیادہ کرنے کے لیے روزانہ آرڈرز مکمل کریں',
  orders_tips_2: 'مناسب تکمیل کو یقینی بنانے کے لیے پروسیسنگ کے دوران صفحہ پر رہیں',
  orders_tips_3: 'کمیشن میں اضافے کو ٹریک کرنے کے لیے باقاعدگی سے اپنا والٹ چیک کریں',
  orders_tips_4: 'دوستوں کو ریفر کریں تاکہ ان کے آرڈرز سے بونس کمیشن حاصل کر سکیں',
  orders_tips_5: 'اگر آپ کو کوئی مسئلہ درپیش ہو تو فوری طور پر سپورٹ سے رابطہ کریں',
  orders_batch_approx: '{{count}} آرڈرز فی بیچ × اوسط ${{avg}} = تقریباً ${{total}} فی بیچ',

  // Settings
  settings_page_title: 'ترتیبات',
  settings_page_desc: 'اپنی سیکیورٹی، رازداری اور ترجیحات کا نظم کریں',
  settings_kyc_label: 'KYC کی تصدیق',
  settings_kyc_desc: 'شناخت کی تصدیق',
  settings_security_label: 'سیکیورٹی',
  settings_security_desc: 'پاس ورڈ کا انتظام',
  settings_language_label: 'زبان',
  settings_language_desc: 'علاقائی ترجیحات',

  // Support
  support_btn_send: 'جواب بھیجیں',
  support_edit_message: 'پیغام میں ترمیم کریں',
  support_delete_message: 'پیغام حذف کریں',
  support_delete_confirm: 'کیا آپ واقعی اس پیغام کو حذف کرنا چاہتے ہیں؟',
  support_message_updated: 'پیغام کامیابی کے ساتھ اپ ڈیٹ ہو گیا',
  support_message_deleted: 'پیغام کامیابی کے ساتھ حذف ہو گیا',
  support_err_already_read: 'پیغام دیکھے جانے کے بعد اس میں ترمیم نہیں کی جا سکتی۔',
  // ڈپازٹ موڈل
  deposit_modal_title_method: "ادائیگی کا طریقہ منتخب کریں",
  deposit_modal_title_gateway: "کرپٹو والٹ منتخب کریں",
  deposit_modal_title_plan: "ڈپازٹ پلان منتخب کریں",
  deposit_modal_title_details: "ڈپازٹ کی تفصیلات",
  deposit_modal_step_method: "طریقہ",
  deposit_modal_step_gateway: "والٹ",
  deposit_modal_step_plan: "پلان",
  deposit_modal_step_details: "تفصیلات",
  deposit_modal_credit_card: "کریڈٹ کارڈ / ڈیبٹ کارڈ",
  deposit_modal_bank_transfer: "بینک ٹرانسفر",
  deposit_modal_ewallet: "الیکٹرانک والٹ",
  deposit_modal_digital_currency: "ڈیجیٹل کرنسی",
  deposit_modal_not_available: "آپ کے علاقے میں دستیاب نہیں ہے",
  deposit_modal_available_recommended: "دستیاب — تجویز کردہ",
  deposit_modal_back_to_method: "ادائیگی کے طریقوں پر واپس جائیں",
  deposit_modal_back_to_gateway: "والٹ کی فہرست پر واپس جائیں",
  deposit_modal_back_to_plan: "پلانز پر واپس جائیں",
  deposit_modal_digital_selected: "ڈیجیٹل کرنسی منتخب کی گئی",
  deposit_modal_digital_hint: "ایڈریس اور ہدایات حاصل کرنے کے لیے اپنا کرپٹو والٹ منتخب کریں۔",
  deposit_modal_loading_wallets: "والٹس لوڈ ہو رہے ہیں...",
  deposit_modal_no_wallets: "کوئی کرپٹو والٹ دستیاب نہیں ہے۔",
  deposit_modal_loading_plans: "پلانز لوڈ ہو رہے ہیں...",
  deposit_modal_no_plans: "اس وقت کوئی ڈپازٹ پلان دستیاب نہیں ہے۔",
  deposit_modal_duration: "مدت",
  deposit_modal_amounts_profits: "رقم اور منافع",
  deposit_modal_amount_label: "رقم",
  deposit_modal_profit_label: "منافع",
  deposit_modal_benefits: "فوائد",
  deposit_modal_continue: "جاری رکھیں",
  deposit_modal_transfer_details: "{{name}} کے لیے ٹرانسفر کی تفصیلات",
  deposit_modal_deposit_amount: "ڈپازٹ کی رقم",
  deposit_modal_amount_fixed: "رقم آپ کے منتخب کردہ پلان کے مطابق طے ہے",
  deposit_modal_txn_id: "ٹرانزیکشن آئی ڈی",
  deposit_modal_txn_optional: "(اختیاری)",
  deposit_modal_txn_placeholder: "مثال کے طور پر 0x1a2b3c4d...",
  deposit_modal_screenshot: "اسکرین شاٹ",
  deposit_modal_upload_proof: "ادائیگی کا ثبوت اپ لوڈ کریں",
  deposit_modal_upload_hint: "PNG, JPG, JPEG — زیادہ سے زیادہ 5MB",
  deposit_modal_comments: "تبصرے",
  deposit_modal_comments_placeholder: "کوئی اضافی معلومات...",
  deposit_modal_notice: "جمع کرانے کے بعد، ہماری ٹیم آپ کی ادائیگی کی تصدیق کرے گی اور 5-30 منٹ کے اندر آپ کے اکاؤنٹ میں رقم جمع کر دی جائے گی۔",
  deposit_modal_confirm: "ڈپازٹ کی تصدیق کریں",
  deposit_modal_submitting: "جمع ہو رہا ہے...",
  deposit_modal_err_fields: "براہ کرم تمام مطلوبہ فیلڈز پر کریں",
  deposit_modal_err_submit: "جمع کرانے کے دوران ایک خرابی پیش آئی",
  deposit_modal_success: "ڈپازٹ کی درخواست کامیابی سے مکمل ہو گئی!",
  deposit_modal_err_plans: "ڈپازٹ پلانز لوڈ کرنے میں ناکامی",
  deposit_modal_err_wallets: "ادائیگی کے طریقے لوڈ کرنے میں ناکامی",
  deposit_modal_new_to_crypto: "کرپٹو میں نئے ہیں؟ ڈیجیٹل کرنسی خریدنا سیکھیں",
  deposit_modal_crypto_label: "کرپٹو",
  orders_insufficient_balance: "کم بیلنس",
  orders_balance_gap_msg1: "آپ کا موجودہ بیلنس اس آرڈر کو مکمل کرنے کے لیے کافی نہیں ہے۔",
  orders_balance_gap_msg2_start: "براہ کرم اپنا کمیشن حاصل کرنے کے لیے",
  orders_balance_gap_msg2_end: "شامل کریں۔",
  orders_btn_add_funds: "فنڈز شامل کریں",
  withdrawal_restricted_support: "سپورٹ سے رابطہ کریں",
};
